import { render, staticRenderFns } from "./ConfirmationComponent.vue?vue&type=template&id=0bb948ee"
import script from "./ConfirmationComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports